/**
 * 从URL中获取sn参数（支持query和hash两种方式）
 * @returns {string} sn参数值
 */
export const getSnFromUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const hashParams = new URLSearchParams(window.location.hash.split("?")[1] || "");
    return urlParams.get("sn") || hashParams.get("sn") || "";
};

/**
 * 重新获取token并更新window.webimToken
 * @param {number} type - webIM类型
 * @returns {Promise<{type: number, token: string, access: string}>}
 */
export const refreshToken = async (type = 5) => {
    const axios = await import("axios");
    const CryptoJS = await import("crypto-js");
    const sn = getSnFromUrl();

    let timestamp = new Date().getTime();
    let signKey = "55849887AA2E4087B5DB09D1D47C1C9A";
    let md5String = "";
    md5String += "&" + timestamp + "&" + signKey;
    let sign = CryptoJS.MD5(md5String).toString();

    const res = await axios.default.get(`https://chat-api.dometa.net/v1/api/chat/get_token?ts=${timestamp}&sign=${sign}&name=${sn}`);
    if (res && res.data && res.data.code === 200) {
        const demoToken = res.data.data.token;
        // 更新配置数据
        window.$appConfig = res.data.data;
        // 更新window.webimToken
        if (window.webimToken && window.webimToken.length > 0) {
            const index = window.webimToken.findIndex((item) => item.type === type);
            if (index !== -1) {
                window.webimToken[index].token = demoToken;
            }
        }
        return {
            type: type,
            token: demoToken,
            access: "ws",
        };
    }
    throw new Error("获取token失败");
};

/**
 * 获取 location hash 参数
 * @param {string} variable 参数名
 * @returns {string} 参数值
 */
export const getQueryVariable = (variable) => {
    const query = window.location.hash.split("?");

    if (query.length < 2) {
        return "";
    }

    const vars = query[1].split("&");

    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split("=");
        if (pair[0] === variable) {
            return decodeURI(pair[1]);
        }
    }
    return "";
};

/**
 * 滚动至指定dom底部
 */
export const scrollToBottom = (sDom, sTop) => {
    if (!sDom) return;

    sDom.scrollTo({
        top: sTop,
        // behavior: 'smooth'
    });
};

/**
 * 数组去重
 */
export const arrayUnique = (arr, replaceKey, holdKey) => {
    let temp = {};

    return arr.reduce((prev, cur) => {
        if (!temp[cur[replaceKey]]) {
            temp[cur[replaceKey]] = { index: prev.length };
            prev.push(cur);
        } else {
            const oldItem = temp[cur[replaceKey]];
            cur[holdKey] = oldItem[holdKey];
            prev.splice(oldItem["index"], 1, cur);
        }

        return prev;
    }, []);
};

export const generateRequestId = (length = 32) => {
    // 腾讯云要求 RequestId 匹配 ^[a-zA-Z0-9_-]{32,64}$，此处固定生成 32-64 位随机串
    const data = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_";
    const len = Math.min(Math.max(Number(length) || 32, 32), 64);
    let nums = "";
    for (let i = 0; i < len; i++) {
        const r = parseInt(Math.random() * data.length, 10);
        nums += data[r];
    }
    return nums;
};

function escapeHtml(str) {
    return str.replace(/[&<>"'/]/g, function (match) {
        return {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
            "/": "&#x2F;",
        }[match];
    });
}

export const escapeUserInput = (input) => {
    const parts = input.split(/(<script[^>]*>.*?<\/script>|<[^>]*>)/gi);
    return parts
        .map((part) => {
            if (part.startsWith("<script")) {
                return escapeHtml(part);
            } else if (part.startsWith("<")) {
                return escapeHtml(part);
            } else {
                return part;
            }
        })
        .join("");
};



// WEBPACK FOOTER //
// ./src/utils/util.js